<div (click)="selectItem()" (keydown.enter)="selectItem()" (keydown.space)="selectItem()" class="btn btn--selection"
    [ngClass]="{selected: selected, last:last}">
    {{item.name ? item.name : '-'}}
</div>
